var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCrossBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.4047,
    height: 14.0043,
    rx: 2.80086,
    fill: "#EE534F",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4252_8936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53993 4.83648C5.66566 4.71075 5.8695 4.71076 5.99522 4.83648L7.70256 6.54381L9.40989 4.83648C9.53561 4.71076 9.73945 4.71076 9.86518 4.83648C9.99091 4.96222 9.9909 5.16605 9.86518 5.29178L8.15785 6.9991L9.86517 8.70643C9.99089 8.83215 9.9909 9.03599 9.86517 9.16172C9.73944 9.28744 9.53561 9.28744 9.40988 9.16172L7.70256 7.45439L5.99523 9.16172C5.8695 9.28744 5.66567 9.28745 5.53994 9.16172C5.41421 9.03599 5.41422 8.83216 5.53994 8.70643L7.24727 6.9991L5.53993 5.29177C5.41421 5.16604 5.4142 4.96221 5.53993 4.83648Z",
    fill: "#EE5D50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4252_8936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.66809,
    height: 4.66809,
    fill: "white",
    transform: "matrix(-1 0 0 1 10.0366 4.66797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCrossBox);
export default __webpack_public_path__ + "static/media/red_cross_box.202bd1a11755ace36ceb4e8c72e3340d.svg";
export { ForwardRef as ReactComponent };